import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalServices } from '../../services/global.service';
import { ssApiService } from '../../services/ss-api.service';

@Component({
    selector: 'login-from-software',
    templateUrl: './login.from.software.component.html',
    styleUrls: ['./login.from.software.component.scss']
})
export class LoginFromSoftwareComponent implements OnInit, OnDestroy {

    routeParams: object;
    paramsSubscribe: any;

    constructor(private route: ActivatedRoute, private router: Router, private gb: GlobalServices, private api: ssApiService) {

    }

    ngOnInit() {
        this.paramsSubscribe = this.route.params.subscribe(params => {


            // get the token from url and re-convert from friendlyurl
            let token: string = params['loginToken'].toString();
            token = GlobalServices.ConverFromUrlFriendly(token);

            // set the token tot he globals so that our server request has a bearer header
            this.gb.SetToken(token);

            // get session info
            let subscription = this.api.GetSessionInfo().subscribe(response => {
                subscription.unsubscribe();

                // check on error
                if (!response.Result) {
                    this.router.navigate(['/authentication']);
                    return;
                }

                // set the globals and skip token
                this.gb.SetGlobalsFromLoginResponse(response.Data, true);

                // redirect to global redirect after successfull login
                
                if (response.Data.Redirect != null)
                    this.router.navigate([response.Data.Redirect]);
                else
                    this.router.navigate(['/account/add-credit-card']);
            });


        }, error => {
            this.router.navigate(['/authentication']);
        });

    }

    ngOnDestroy() {
        this.paramsSubscribe.unsubscribe();
    }

}
